import { Form, Input, Row } from "antd";
import { GetFieldDecoratorOptions } from "antd/lib/form/Form";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { nameof } from "src/core/utils/object";
import { WhatsNewReportItem } from "../../../../stores/whats-new-store";
import RichTextView from "../../../../core/ui/form/rich-editor.view";
import 'src/assets/custom.scss'

let FormItem = Form.Item;

interface WhatsNewReportFormProps extends WithTranslation {
    item: WhatsNewReportItem | undefined;
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(
        id: keyof T,
        options?: GetFieldDecoratorOptions
    ): (node: React.ReactNode) => React.ReactNode;
}

class WhatsNewReportForm extends React.Component<WhatsNewReportFormProps> {
    render() {
        const { t } = this.props;
        var tooltipItem = this.props.item || ({} as WhatsNewReportItem);
        return (
            <>
                <Row>
                    <FormItem label={t("Insert text for Users")}>
                        {this.props.getFieldDecorator(nameof<WhatsNewReportItem>("text"), {
                            initialValue: tooltipItem.text,
                            rules: [{ required: true, message: `* ${t("Text required")}` }],
                        })(
                            <RichTextView value={tooltipItem.text} containerClassName="custom-wysiwyg-editor" />
                        )}
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label={t("Insert text for Managers")}>
                        {this.props.getFieldDecorator(nameof<WhatsNewReportItem>("adminText"), {
                            initialValue: tooltipItem.adminText,
                            rules: [{ required: true, message: `* ${t("Text required")}` }],
                        })(
                            <RichTextView value={tooltipItem.text} containerClassName="custom-wysiwyg-editor" />
                        )}
                    </FormItem>
                </Row>
            </>

            
        );
    }
}

export default withTranslation()(WhatsNewReportForm);
